export default __webpack_public_path__ + "static/media/001-balloon-blue.33fc575b.svg";